import styled from 'styled-components/macro';

import loading from '../../assets/images/loading.png';
import { Tab, Tabs, TabPanel, TabList } from 'react-tabs';

// utils
import mq from '../../utils/mediaQueriesBp';

import ResponsiveContainer from '../../components/layout/ResponsiveContainer';
import H1 from '../../atoms/H1';

interface IProps {
  isSticky: boolean;
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
  padding-top: 12px;
  overflow: hidden;
  z-index: 1;

  ${mq('laptop')} {
    padding-top: 56px;
  }

  img {
    width: 100%;
  }

  .react-tabs {
    width: 100%;
  }
`;
const Container = styled(ResponsiveContainer)``;

const LoadMoreRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 56px 0 40px;

  ${mq('tablet')} {
    flex-direction: row;
  }
`;

export { Wrapper, Container, LoadMoreRow };
